<template lang="pug">
  .preloader(:class="size")
    .bounce-1
    .bounce-2
    div
</template>

<script>
export default {
  props: {
    size: { type: String, default: 'md' }
  }
};
</script>

<style scoped lang="scss">
  @import '../assets/scss/variables';

  .preloader {
    margin: auto;
    text-align: center;

    & > div {
      background-color: $blue;
      border-radius: 100%;
      display: inline-block;
      animation: preloader 1.4s ease-in-out 0s infinite both;
    }

    &.lg > div {
      width: 50px;
      height: 50px;
    }

    &.md > div {
      width: 30px;
      height: 30px;
    }

    &.sm > div {
      width: 20px;
      height: 20px;
    }

    .bounce-1 { animation-delay: -0.32s; }

    .bounce-2 { animation-delay: -0.16s; }

    @keyframes preloader {
      0%,
      80%,
      100% {
        transform: scale(0);
      }

      40% { transform: scale(1); }
    }
  }
</style>
